import { render, staticRenderFns } from "./DoctorSchedule.vue?vue&type=template&id=08d9a220&lang=pug&"
import script from "./DoctorSchedule.vue?vue&type=script&lang=js&"
export * from "./DoctorSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports